// These values are intentionally kept in backend order. The accompanying test
// compares them with the backend allow-lists so the admin UI cannot silently
// lose newly mintable scopes or subscribable webhook events.
export const API_SCOPES = [
  { value: 'employees:read', labelKey: 'admin.integrations.apiClients.scopeEmployeesRead' },
  { value: 'employees:write', labelKey: 'admin.integrations.apiClients.scopeEmployeesWrite' },
  { value: 'customers:read', labelKey: 'admin.integrations.apiClients.scopeCustomersRead' },
  { value: 'customers:write', labelKey: 'admin.integrations.apiClients.scopeCustomersWrite' },
  { value: 'placements:write', labelKey: 'admin.integrations.apiClients.scopePlacementsWrite' },
  { value: 'weeks:read', labelKey: 'admin.integrations.apiClients.scopeWeeksRead' },
  { value: 'hours:read', labelKey: 'admin.integrations.apiClients.scopeHoursRead' },
  { value: 'disputes:read', labelKey: 'admin.integrations.apiClients.scopeDisputesRead' },
  { value: 'payroll:read', labelKey: 'admin.integrations.apiClients.scopePayrollRead' },
  { value: 'changes:read', labelKey: 'admin.integrations.apiClients.scopeChangesRead' },
  { value: 'directory:read', labelKey: 'admin.integrations.apiClients.scopeDirectoryRead' },
  { value: 'economic:read', labelKey: 'admin.integrations.apiClients.scopeEconomicRead' },
  { value: 'financial:salary:read', labelKey: 'admin.integrations.apiClients.scopeSalaryTermsRead' },
  { value: 'financial:salary:write', labelKey: 'admin.integrations.apiClients.scopeSalaryTermsWrite' },
  { value: 'financial:billing:read', labelKey: 'admin.integrations.apiClients.scopeBillingTermsRead' },
  { value: 'financial:billing:write', labelKey: 'admin.integrations.apiClients.scopeBillingTermsWrite' },
];

// The VikarCRM v2 client must have this complete set. Keep the preset separate
// from API_SCOPES: the latter also contains legacy-only permissions which must
// not accidentally be presented as sufficient for the v2 contract.
export const VIKARCRM_V2_REQUIRED_SCOPES = Object.freeze([
  'customers:read',
  'customers:write',
  'employees:read',
  'employees:write',
  'placements:write',
  'hours:read',
  'payroll:read',
  'changes:read',
]);

export const WEBHOOK_EVENT_TYPES = [
  { value: 'timereporting.week.submitted', labelKey: 'admin.integrations.webhooks.eventWeekSubmitted' },
  { value: 'timereporting.week.approved', labelKey: 'admin.integrations.webhooks.eventWeekApproved' },
  { value: 'timereporting.week.challenged', labelKey: 'admin.integrations.webhooks.eventWeekChallenged' },
  { value: 'timereporting.week.resolved', labelKey: 'admin.integrations.webhooks.eventWeekResolved' },
  { value: 'timereporting.hours.changed', labelKey: 'admin.integrations.webhooks.eventHoursChanged' },
  { value: 'timereporting.invoice.pushed', labelKey: 'admin.integrations.webhooks.eventInvoicePushed' },
  { value: 'timereporting.payroll.pushed', labelKey: 'admin.integrations.webhooks.eventPayrollPushed' },
  { value: 'timereporting.employee.created', labelKey: 'admin.integrations.webhooks.eventEmployeeCreated' },
  { value: 'timereporting.employee.updated', labelKey: 'admin.integrations.webhooks.eventEmployeeUpdated' },
  { value: 'timereporting.customer.created', labelKey: 'admin.integrations.webhooks.eventCustomerCreated' },
  { value: 'timereporting.customer.updated', labelKey: 'admin.integrations.webhooks.eventCustomerUpdated' },
  { value: 'timereporting.work_period.changed.v2', labelKey: 'admin.integrations.webhooks.eventWorkPeriodChangedV2' },
  { value: 'timereporting.payroll_period.changed.v2', labelKey: 'admin.integrations.webhooks.eventPayrollPeriodChangedV2' },
  { value: 'timereporting.placement.changed.v2', labelKey: 'admin.integrations.webhooks.eventPlacementChangedV2' },
];

export const VIKARCRM_V2_REQUIRED_WEBHOOK_EVENTS = Object.freeze([
  'timereporting.work_period.changed.v2',
  'timereporting.payroll_period.changed.v2',
  'timereporting.placement.changed.v2',
]);

// Never infer ownership from a human-readable webhook name or URL. The server
// validates this canonical tag and readiness counts tagged subscriptions only.
export const VIKARCRM_V2_INTEGRATION_PROVIDER = 'vikarcrm_v2';
